import Contact from "../components/Contact";
import Map from "../components/Map";
import CTA from "../components/CTA";
import Team from "../components/Team";

const ContactPage = () => {
	return (
		<div className="contact-page">
			<section className="page-header">
				<div className="containerr pt-10">
					<h1>Contact Us</h1>
					<p>We'd love to hear from you. Get in touch with our team.</p>
				</div>
			</section>

			<Contact />

			<Map />
			<Team />
			<CTA />
		</div>
	);
};

export default ContactPage;
